import { Component, OnInit, Input } from '@angular/core';
import { PlanAttributes, SummaryView } from '../../interfaces/plan-attributes.interface';
import { Product } from '../../interfaces/product.interface';
import { PlanDetailsRenderableGroup } from '../types/plan-details.types';
import { BooleanInput } from '@ptl/global-components';
import { ENROLLMENT_FLOW } from 'src/app/angular-elements/form-wrappers/plan-enrollment/individual-plan-enrollment-form/configs/interfaces/enrollment-flow.enum';

@Component({
    selector: 'app-compare-plans-header',
    templateUrl: './compare-plans-header.component.html',
    styleUrls: ['./compare-plans-header.component.scss'],
    standalone: false
})
export class ComparePlansHeaderComponent implements OnInit {

  @Input() plans: Product<PlanAttributes, SummaryView>[];
  @Input() enrollStartUrl: string;
  @Input() iconographyDetails: PlanDetailsRenderableGroup;
  @Input() viewPlansUrl: string;
  @Input() recommendedPlansUrl: string;
  @Input() specialEnrollmentUrl: string;
  @Input() showSaveQuoteButton: string | boolean;
  @Input() saveQuoteText: string;
  @Input() returnUrl: string;
  @Input() enrollmentFlow: string;
  @Input() quoteButtonPage: string;
  @Input() @BooleanInput() enableNewPrintExperience: boolean;

  isSep: boolean;

  sortedPlanNames;

  constructor(

  ) { }

  ngOnInit() {
    this.isSep = this.enrollmentFlow === ENROLLMENT_FLOW.SEP_PAPER || this.enrollmentFlow === ENROLLMENT_FLOW.SEP_ELECTRONIC ? true : false;
    this.sortedPlanNames = this.plans.sort((a, b) => {
      if (a.attributes.PLAN_ID < b.attributes.PLAN_ID) { return -1; }
      if (a.attributes.PLAN_ID > b.attributes.PLAN_ID) { return 1; }
      return 0;
    });
  }

  print() { }
}
